import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ScrollText } from 'lucide-react';

export const Terms = () => {
  return (
    <div className="min-h-screen py-20 bg-gradient-to-br from-hr-warm-bg via-white to-hr-teal-light/10 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-hr-teal/5 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-hr-purple/5 rounded-full blur-3xl animate-float-slow" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <article className="bg-white rounded-2xl shadow-2xl p-8 lg:p-12 animate-fade-in-up">
          <header className="mb-12 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-hr-teal-light mb-6 animate-bounce-subtle">
              <ScrollText className="h-8 w-8 text-hr-teal" />
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-hr-text-primary mb-4 animate-fade-in-up stagger-1" style={{ opacity: 0 }}>
              Terms & Conditions
            </h1>
            <p className="text-hr-text-muted animate-fade-in-up stagger-2" style={{ opacity: 0 }}>Last Updated: 1/15/2026</p>
          </header>

          <div className="prose prose-lg max-w-none text-hr-text-secondary animate-fade-in-up stagger-3" style={{ opacity: 0 }}>
            <p className="lead">
              Welcome to HR Nest. By accessing or using our website, services, programs, or resources, you agree to be bound by these Terms & Conditions.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing HR Nest's website, services, membership platforms, or any related content, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions and our Privacy Policy.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">2. Services Description</h2>
            <p>
              HR Nest provides educational content, career development resources, community support, coaching services, and related materials. All services are designed to support individuals in their career and personal development journeys.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">3. User Responsibilities</h2>
            <p>You agree to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide accurate information when creating an account or making purchases</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Use our services in compliance with applicable laws</li>
              <li>Respect other community members and follow our Community Guidelines</li>
              <li>Not share or redistribute proprietary content without permission</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">4. Membership Terms</h2>
            <p>
              Membership subscriptions are billed according to the plan selected. You may cancel your membership at any time, but no refunds will be issued for the current billing period. HR Nest reserves the right to modify membership benefits with reasonable notice.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">5. Intellectual Property</h2>
            <p>
              All content, materials, templates, and resources provided by HR Nest are protected by intellectual property rights. You may use these materials for personal, non-commercial purposes only unless otherwise specified.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">6. Disclaimer of Warranties</h2>
            <p>
              HR Nest services are provided "as is" without warranties of any kind. We do not guarantee specific outcomes from using our services. See our <Link to="/disclaimer" className="text-hr-purple hover:underline">Disclaimer</Link> for more details.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">7. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, HR Nest shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">8. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your access to our services for violations of these Terms, Community Guidelines, or for any other reason at our discretion.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">9. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the State of Indiana, United States.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">10. Changes to Terms</h2>
            <p>
              We may update these Terms periodically. Continued use of our services after changes constitutes acceptance of the revised Terms.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Contact Us</h2>
            <p>
              If you have questions about these Terms, please contact us at:<br />
              📧 Email: HRnestllc@gmail.com
            </p>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Terms;
